import { render, staticRenderFns } from "./SystemAdminComponent.vue?vue&type=template&id=bfece5f4&scoped=true&"
import script from "./SystemAdminComponent.vue?vue&type=script&lang=js&"
export * from "./SystemAdminComponent.vue?vue&type=script&lang=js&"
import style0 from "./SystemAdminComponent.vue?vue&type=style&index=0&id=bfece5f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfece5f4",
  null
  
)

export default component.exports